/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  class LearningJourneyAnimate {
    constructor(element) {
      this.container = element;
      this.selectors = {
        steps: "[data-step-index]",
        progressItem: "[data-step-progress-item]",
        progressActive: "[data-progress-active]",
        progressInctive: "[data-progress-inactive]",
      }

      this.steps = this.container.querySelectorAll(this.selectors.steps);
      this.stepNumbers = this.container.querySelectorAll(this.selectors.progressItem);
      this.totalSteps = this.stepNumbers.length - 1;
      this.progressActive = this.container.querySelector(this.selectors.progressActive);

      this.bindEvents();
    }

    bindEvents() {
      this.container.addEventListener("mouseover", (e) => {
        // If hovering over a step, update progress and activate numbers up to that point
        if (e.target.hasAttribute("data-step-index")) {
          const hoveredIndexAttr = e.target.getAttribute("data-step-index");
          const indexToAnimate = parseInt(hoveredIndexAttr, 10);
          const scaleVal = (indexToAnimate / this.totalSteps);
          this.progressActive.style.transform = `scale(${scaleVal})`;

          for (var i = 0; i < this.stepNumbers.length; i++) {
            const numberMatch = this.container.querySelector(`[data-step-progress-item="${i}"] .learning-journey__progress-number`);
            if (i <= indexToAnimate) {
              numberMatch.classList.add("learning-journey__progress-number--active");
            } else {
              numberMatch.classList.remove("learning-journey__progress-number--active");
            }
          }
        }

        // If not hovering over the grid, return progress to 0 and revert numbers to inactive
        if (!e.target.closest("[data-grid-wrapper]")) {
          this.progressActive.style.transform = `scale(0)`;
          this.stepNumbers.forEach((el) => el.querySelector(".learning-journey__progress-number").classList.remove("learning-journey__progress-number--active"));
        }
      });
    }
  }

  const learningJourneys = document.querySelectorAll("[data-learning-journey]");
  if (learningJourneys) learningJourneys.forEach((el) => new LearningJourneyAnimate(el));

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
